<template>
  <j-modal :title="title"  :width="1000" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '650px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="disableSubmit">
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-model-item :label="$t('任务名称')" prop="taskName">
                <a-input v-model="model.taskName" :disabled="!disableSubmit"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('任务类型')" prop="taskCategory">
                <a-select :placeholder="$t('请选择任务类型')" v-model="model.taskCategory" :disabled="!disableSubmit">
                  <a-select-option :value="0">{{ $t('临时任务') }}</a-select-option>
                  <a-select-option :value="1">{{ $t('日常任务') }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('巡检计划')" prop="planId">
                <a-input v-model="model.planName" :disabled="!disableSubmit"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('结束时间')" prop="taskEndTime">
                <a-date-picker v-model="model.taskEndTime" :placeholder="$t('请选择结束时间')" format="YYYY-MM-DD HH:mm:ss" style="width: 100%;" :disabled="!disableSubmit" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('备注')" prop="remark">
                <a-textarea v-model="model.remark" :placeholder="$t('请输入备注信息')" :rows="4" :disabled="!disableSubmit" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <div v-for="(item,index) in model.inspectionTaskRouteInnerList" class="device-box" :key="item.id">
            <a-divider orientation="left">{{ $t('巡检路线') }}{{++index}}</a-divider>
            <a-form-model :ref="`formP${item.id}`" :model="item" :rules="validatorRules" slot="detail" :colon="false">
              <a-row :gutter="24">
                <a-col :span="6">
                  <a-form-model-item :label="$t('路线状态')" prop="routeState">
                    <a-select :placeholder="$t('请选择路线状态')" v-model="item.routeState">
                      <a-select-option :value="0">{{ $t('完成') }}</a-select-option>
                      <a-select-option :value="1">{{ $t('未完成') }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t('路线类型')" prop="routeType">
                    <a-select v-model="item.routeType" :disabled="!disableSubmit">
                      <a-select-option :value="0">{{ $t('管线') }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t('路线名称')" prop="routeName">
                    <a-input v-model="item.routeName" :disabled="!disableSubmit"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t('里程数')" prop="routeMileage">
                    <a-input v-model="item.routeMileage" :disabled="!disableSubmit"></a-input>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <div v-for="(cld,cldIndex) in item.inspectionTaskRouteDeviceInnerList" style="padding-left: 20px;" :key="cld.id">
                <a-divider orientation="left">{{ $t('设备') }}{{++cldIndex}}</a-divider>
                <a-form-model :ref="`formC${cld.id}`" :model="cld" :rules="validatorRules" slot="detail" :colon="false">
                  <a-row :gutter="24">
                    <a-col :span="6">
                      <a-form-model-item :label="$t('设备编号')" prop="detectNum">
                        <a-input v-model="cld.detectNum" :disabled="!disableSubmit"></a-input>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="6">
                      <a-form-model-item :label="$t('设备类型')" prop="routeType">
                        <a-select v-model="cld.detectType" :disabled="!disableSubmit">
                          <a-select-option :value="0">{{ $t('设备') }}</a-select-option>
                        </a-select>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="6">
                      <a-form-model-item :label="$t('设备名称')" prop="deviceName">
                        <a-input v-model="cld.deviceName" :disabled="!disableSubmit"></a-input>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="6">
                      <a-form-model-item :label="$t('设备经度')" prop="detectLongitude">
                        <a-input v-model="cld.detectLongitude" :disabled="!disableSubmit"></a-input>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="6">
                      <a-form-model-item :label="$t('设备纬度')" prop="detectLatitude">
                        <a-input v-model="cld.detectLatitude" :disabled="!disableSubmit"></a-input>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="6">
                      <a-form-model-item label=" ">
                        <a-button type="primary" @click="updateContent(cld)" icon="form">{{cld.visible?$t('关闭更新内容'):$t('打开更新内容')}}</a-button>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24" v-if="cld.visible">
                    <a-col :span="6">
                      <a-form-model-item :label="$t('是否正常')" prop="isOk">
                        <a-select :placeholder="$t('请选择是否正常')" v-model="cld.isOk">
                          <a-select-option :value="0">{{ $t('正常') }}</a-select-option>
                          <a-select-option :value="1">{{ $t('异常') }}</a-select-option>
                        </a-select>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="18">
                      <a-form-model-item :label="$t('结果描述')" prop="resultDescription">
                        <a-textarea :placeholder="$t('请输入结果描述')" v-model="cld.resultDescription" :rows="4" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </a-form-model>
              </div>
            </a-form-model>
          </div>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>

<script>
  // import {
  //   JeecgListMixin
  // } from '@/mixins/JeecgListMixin';
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  import { includes } from 'xe-utils/methods';
  export default {
    // mixins: [JeecgListMixin],
    name: 'inspectionTaskUpdateModal',
    components: {},
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        model: {},
        url: {
          add: "/jeecg-engineering/inspection/inspectionTask/add",
          edit: "/jeecg-engineering/inspection/inspectionTask/edit",
          queryById: "/jeecg-engineering/inspection/inspectionTask/queryById",
          list: "/jeecg-engineering/inspection/inspectionPlan/list",
        },
      }
    },
    computed: {
      validatorRules() {
        return {
          // routeState: [{
          //   required: true,
          //   message: '请选择路线状态',
          //   trigger: 'change'
          // }],
          isOk: [{
            required: true,
            message: this.$t('请选择设备是否正常'),
            trigger: 'change'
          }],
          resultDescription: [{
            required: true,
            message: this.$t('请输入结果描述'),
            trigger: 'blur'
          }]
        }
      },
    },
    methods: {
      updateContent(row) {
        this.model.inspectionTaskRouteInnerList.forEach(line=>{
          line.inspectionTaskRouteDeviceInnerList.forEach(device=>{
            if(device.id == row.id){
              this.$set(device,'visible',!row.visible);
              if(!device.visible){
                this.$set(device,'isOk',null);
                this.$set(device,'resultDescription',null);
              }
            }
          });
        });
      },
      getPlanInfo(row) {
        let that = this;
        getAction(this.url.queryById,{id:row.id}).then(res=>{
          if(res.success){
            this.model = Object.assign(res.result);
            that.model.inspectionTaskRouteInnerList.forEach(line=>{
              line.inspectionTaskRouteDeviceInnerList.forEach(device=>{
                that.$set(device,'visible',false);
              });
            });
          }
        });
      },
      init(row){
        this.visible = true;
        this.title = this.$t('更新任务');
        this.model = JSON.parse(JSON.stringify(row));
        this.getPlanInfo(row);
        this.$nextTick(() => {
          this.$refs.form.clearValidate();
        });
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleOk() {
        const that = this;
        // 触发表单验证
        let formLineValid = [];
        let formDeviceValid = [];
        this.model.inspectionTaskRouteInnerList.forEach((line,index)=>{
          // let refLine = 'formP'+(++index);
          // that.$refs[refLine][0].validate(valid=>{
          //   if(valid){
          //     formLineValid.push(true);
          //   }else{
          //     formLineValid.push(false);
          //   }
          // });
          line.inspectionTaskRouteDeviceInnerList.forEach((device,dIndex)=>{
            let refDevice = `formC${device.id}`;
            that.$refs[refDevice][0].validate(valid=>{
              if(valid){
                formDeviceValid.push(true);
              }else{
                formDeviceValid.push(false);
              }
            });
          });
        });
        this.$refs.form.validate(valid => {
          // && !formLineValid.includes(false)
          if (valid  && !formDeviceValid.includes(false)) {
            that.confirmLoading = true;
            postAction(this.url.edit, this.model).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
                this.visible = false;
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      handleCancel() {
        this.close()
      },
      
      onInput(e) {debugger
         this.$forceUpdate();
      },
    }
  }
</script>
<style scoped lang="less">
  .device-box{
    background-color: rgba(24, 144, 255, 0.1);
    padding: 20px;
    margin: 10px 0;
  }
  /deep/.ant-divider-inner-text{
    color: rgba(24, 144, 255, 0.85);
    font-size: 16px;
  }
  .ant-divider-horizontal.ant-divider-with-text-left::after,
  .ant-divider-horizontal.ant-divider-with-text-left::before{
    border-color: rgba(24, 144, 255, 0.2);
  }
</style>